(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbContentTypeGroupsConfigDataStore', ['$q', 'smbLibraryConfigService', ContentTypeGroupsConfigDataStore]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypeGroupsConfigDataStore
	 * 
	 * @description
	 * A data store for managing local content type groups state for
	 * the configuration section.
	 */
	function ContentTypeGroupsConfigDataStore($q, smbLibraryConfigService) {
		var _groups;

		return {
			/**
			 * @ngdoc property
			 * @name smbContentTypeGroupsConfigDataStore#groups
			 * @propertyOf smb-app.smbContentTypeGroupsConfigDataStore
			 * @kind property
			 * 
			 * @description
			 * An array of all content type groups in the system.
			 */
			get groups() { return _groups; },

			/**
			 * @ngdoc method
			 * @name smbContentTypeGroupsConfigDataStore#loadGroups
			 * @methodOf smb-app.smbContentTypeGroupsConfigDataStore
			 * @kind function
			 * 
			 * @description
			 * Loads all content type groups from the API.
			 * 
			 * @returns {Promise} A promise that resolves to an array of all content type groups in the system.
			 */
			loadGroups: loadGroups,
			/**
			* @ngdoc method
			* @name smbContentTypeGroupsConfigDataStore#deleteGroup
			* @methodOf smb-app.smbContentTypeGroupsConfigDataStore
			* @kind function
			* 
			* @description
			* Deletes a content type group.
			* 
			* @param {Number} groupId The document type group id.
			* @param {Boolean} purge Permanently deleted the document type group if true.
			* @returns {Promise} A promise that resolves if the delete was successful.
			*/
			deleteGroup: deleteGroup
		};

		function loadGroups() {
			return smbLibraryConfigService.getLibraries()
				.then(function (libraries) {
					_groups = libraries.map(function mapLibraryDetails(lib) {
						return {
							id: lib.LibraryId,
							name: lib.LibraryName,
							icon: lib.IconName,
							links: {
								self: lib.Links.Self,
								icon: lib.Links.IconUri
							}
						};
					});

					return _groups;
				});
		}

		function deleteGroup(groupId) {
			if (!groupId) {
				return $q.resolve(new Error('No type ID provided.'));
			} else {
				return smbLibraryConfigService
					.deleteLibrary(groupId)
					.then(function(){
						_groups = _groups.filter(function(library){
							return library.id !== groupId;
						});
					});
			}
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/contentConfigDataStores/contentTypeGroupsConfigDataStore.js
// module id = 109
// module chunks = 1